module.exports = __webpack_public_path__ + "static/media/krx-trading-krx-00.8fc76955.jpg";